import type { SceneAsset } from "./model";

/** Per-document ownership: repeated media has one identity and one archive file. */
export class ResourceCatalog {
  readonly assets: SceneAsset[] = [];
  private readonly bySource = new Map<string, string>();
  private readonly byId = new Map<string, SceneAsset>();
  constructor(assets: readonly SceneAsset[] = []) {
    for (const asset of assets) {
      if (this.byId.has(asset.id)) throw new Error("Повторяющийся ID ресурса.");
      const copy = { ...asset };
      this.assets.push(copy);
      this.byId.set(copy.id, copy);
      this.bySource.set(copy.kind + ":" + copy.source, copy.id);
    }
  }
  add(source: string, kind: SceneAsset["kind"]): string {
    const key = kind + ":" + source;
    const known = this.bySource.get(key);
    if (known) return known;
    let index = this.assets.length + 1;
    while (this.byId.has(`r${index}`)) index++;
    const asset = { id: `r${index}`, kind, source };
    this.assets.push(asset);
    this.byId.set(asset.id, asset);
    this.bySource.set(key, asset.id);
    return asset.id;
  }
  source(id: string): string {
    const asset = this.byId.get(id);
    if (!asset) throw new Error(`Не найден ресурс ${id}.`);
    return asset.source;
  }
}

export function decodeDataUrl(
  source: string,
): { mediaType: string; bytes: Uint8Array } | null {
  const match = /^data:([^,]*),([\s\S]*)$/i.exec(source);
  if (!match) return null;
  const header = match[1]!;
  const body = match[2]!;
  const mediaType = header.split(";")[0] || "application/octet-stream";
  if (/;base64(?:;|$)/i.test(header)) {
    return {
      mediaType,
      bytes: Uint8Array.from(atob(body), (char) => char.charCodeAt(0)),
    };
  }
  const bytes: number[] = [];
  const encoder = new TextEncoder();
  for (const part of body.match(/%[0-9a-f]{2}|[^%]+|%/gi) || []) {
    if (/^%[0-9a-f]{2}$/i.test(part)) bytes.push(parseInt(part.slice(1), 16));
    else for (const byte of encoder.encode(part)) bytes.push(byte);
  }
  return { mediaType, bytes: new Uint8Array(bytes) };
}
